import { Text, Box, Heading, Flex, Image, layout } from '@chakra-ui/react';
import Button from '../../components/Button/Button';
import StyledButton from '../../components/Button/Button';
export interface PlainSectionProps {
    title: string;
    text: JSX.Element;
    layout?: '2/3' | '3/4' | '1/2';
    imageSide?: 'left' | 'right';
    buttons?: {
        title: string;
        href: string;
        variant: 'outline' | 'default' | 'outline-reverted';
    }[];
    image: {
        alt: string;
        url: string;
        mobile?: {
            url: string;
        };
        desktop?: {
            url: string;
        };
    };
}

const PlainSection: React.FC<PlainSectionProps> = ({
    title,
    text,
    buttons,
    image,
    layout,
    imageSide = 'right',
}) => {
    return (
        <Box
            display={'grid'}
            gridTemplateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(12, 1fr)' }}
            gap={'30px'}
        >
            <Flex
                flexDirection={'column'}
                marginBottom={{ base: 8, lg: '0' }}
                gridColumn={{ base: 'span 1', md: layout === '2/3' ? 'span 8' : 'span 9' }}
                textAlign={{
                    base: 'center',
                    lg: 'left',
                }}
                alignItems={{ base: 'center', md: 'flex-start' }}
                justifyContent={'center'}
                order={imageSide === 'right' ? '1' : '2'}
            >
                <Heading
                    as={'h2'}
                    fontWeight={'600'}
                    fontSize={'2.125rem'}
                    lineHeight={'3rem'}
                    marginBottom={'15px'}
                >
                    {title}
                </Heading>
                <Box color={'dark.5'} fontSize={'1.125rem'} lineHeight={'auto'} mb={'15px'}>
                    {text}
                </Box>
                {buttons?.map(button => {
                    return (
                        <StyledButton href={button.href} style={button.variant} target="_self">
                            {button.title}
                        </StyledButton>
                    );
                })}
            </Flex>
            <Flex
                gridColumn={{ base: 'span 1', md: layout === '2/3' ? 'span 4' : 'span 3' }}
                flexDirection={'column'}
                justifyContent={'center'}
                alignItems={'center'}
                flex={'1'}
                order={imageSide === 'right' ? '2' : '1'}
            >
                <Image
                    display={{ md: 'none' }}
                    src={image.mobile?.url ? image.mobile?.url : image.url}
                    alt={image.alt}
                />
                <Image
                    display={{ base: 'none', md: 'block' }}
                    src={image.desktop?.url ? image.desktop?.url : image.url}
                    alt={image.alt}
                />
            </Flex>
        </Box>
    );
};

export default PlainSection;
